import React, { createContext, useMemo, useContext } from 'react';

import { useTaxData } from '../hooks/use-tax-data';

/** @typedef {import('../types/tax-types').UseTaxDataReturnType} UseTaxDataReturnType */

export const TaxDataContext = createContext({});

/**
 * @returns {object | UseTaxDataReturnType}
 */
export const useTaxDataContext = () => useContext(TaxDataContext);

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {React.JSX.Element}
 */
export const TaxDataContextProvider = ({ children }) => {
  const { taxData, isTaxDataAvailable, setTaxData } = useTaxData();

  const value = useMemo(
    () => ({
      taxData,
      isTaxDataAvailable,
      setTaxData,
    }),
    [taxData, isTaxDataAvailable, setTaxData],
  );

  return <TaxDataContext.Provider value={value}>{children}</TaxDataContext.Provider>;
};
